// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._10urJqX\\+USVQ4db68p8YDw\\=\\={display:flex;gap:var(--xds-spacing-d)}", "",{"version":3,"sources":["webpack://./src/shared/components/PIESwitch/PIESwitch.module.scss"],"names":[],"mappings":"AAAA,8BACI,YAAA,CACA,wBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_10urJqX+USVQ4db68p8YDw=="
};
export default ___CSS_LOADER_EXPORT___;
